import React from 'react';
import { CalendarIcon, UsersIcon, LineChartIcon, PuzzleIcon } from 'lucide-react';
export function Features() {
  return <section className="w-full py-16 px-6 md:px-12" data-id="element-211">
      <div className="max-w-6xl mx-auto" data-id="element-212">
        <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-213">
          Supercharge Your Meeting Preparation
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-214">
          <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-215">
            <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-216">
              <CalendarIcon className="h-6 w-6 text-[#C8F169]" data-id="element-217" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-218">Calendar Integration</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-219">
              Connect your Google or Outlook calendar to automatically prepare
              for upcoming meetings.
            </p>
          </div>
          <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-220">
            <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-221">
              <UsersIcon className="h-6 w-6 text-[#C8F169]" data-id="element-222" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-223">Attendee Research</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-224">
              Get detailed profiles on meeting participants, including their
              role, background, and recent activities.
            </p>
          </div>
          <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-225">
            <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-226">
              <LineChartIcon className="h-6 w-6 text-[#C8F169]" data-id="element-227" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-228">Business Insights</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-229">
              Access relevant company data, market trends, and performance
              metrics to make informed decisions.
            </p>
          </div>
          <div className="bg-[#F5F7FA] bg-opacity-5 p-6 rounded-xl" data-id="element-230">
            <div className="w-12 h-12 bg-[#C8F169] bg-opacity-20 rounded-lg flex items-center justify-center mb-4" data-id="element-231">
              <PuzzleIcon className="h-6 w-6 text-[#C8F169]" data-id="element-232" />
            </div>
            <h3 className="text-xl font-semibold mb-3" data-id="element-233">Product Fit Analysis</h3>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-234">
              Understand how your products align with client needs and identify
              opportunities for expansion.
            </p>
          </div>
        </div>
      </div>
    </section>;
}